import { Request } from "./Contexts/Request"

export class StandardError extends Error {}

// TODO: This should be renamed to UnauthenticatedError for better clarity
// Corresponds to GRPC UNAUTHENTICATED and HTTP Status 401
export class AccessDeniedError extends StandardError {
    constructor(message: string | null = null) {
        super(message ?? "AccessDeniedError")
    }
}

// Corresponds to HTTP 403
export class ForbiddenError extends StandardError {
    constructor(message: string | null = null) {
        super(message ?? "ForbiddenError")
    }
}

// Corresponds GRPC HTTP 400
export class BadRequestError extends StandardError {
    constructor(message: string | null = null) {
        super(message ?? "BadRequestError")
    }
}

// Corresponds GRPC HTTP 404
export class NotFoundError extends StandardError {
    constructor(message: string | null = null) {
        super(message ?? "NotFoundError")
    }
}

// Used when resolving paths to distinguish when a path is not found and other errors
export class PathNotFoundError extends NotFoundError {
    constructor(message: string | null = null) {
        super(message ?? "PathNotFoundError")
    }
}

// Corresponds GRPC UNIMPLEMENTED or to HTTP Status 501
export class NotImplementedError extends StandardError {
    constructor(context: Request | null = null) {
        super("NotImplementedError")
    }
}

// Corresponds GRPC HTTP 404
export class TimeoutError extends StandardError {
    constructor(message: string | null = null) {
        super(message ?? "TimeoutError")
    }
}

// Corresponds to GRPC CANCELLED
export class CancelledError extends StandardError {
    constructor(message: string | null = null) {
        super(message ?? "CancelledError")
    }
}

// Corresponds to GRPC ALREADY_EXISTS and loosely to HTTP Status 409
// This is used when a resource already exists and cannot be created again
export class AlreadyExistsError extends StandardError {
    constructor(message: string | null = null) {
        super(message ?? "AlreadyExistsError")
    }
}

export class ODataError extends StandardError {
    status: number

    constructor(message: string | null = null, status: number = 500) {
        super(message ?? "ODataError")
        this.status = status
    }
    
    withStatus(status: number): this {
        this.status = status

        return this
    }
}

export function convertErrorToString(error: unknown): string {
    if (error instanceof Error) {
        return error.message
    }
    return "Unknown error " + JSON.stringify(error)
}
